import { render, staticRenderFns } from "./shipmentListIndex.pug?vue&type=template&id=800b7b24&lang=pug&"
import script from "./shipmentListIndex.ts?vue&type=script&lang=ts&"
export * from "./shipmentListIndex.ts?vue&type=script&lang=ts&"
import style0 from "./shipmentListIndex.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports